"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkComponentEditor = exports.LinkComponentCreator = exports.LinkComponentWebsiteRender = exports.LinkComponentRender = void 0;
const react_1 = __importDefault(require("react"));
// import { AiOutlineOrderedList } from 'react-icons/ai'
const react_bootstrap_1 = require("react-bootstrap");
const structure_1 = require("./structure");
function LinkComponentRender(props) {
    const component = props.component;
    const originalDir = props.originalDir;
    const translatedDir = props.translatedDir;
    const originalLink = component.originalLink;
    const originalLabel = component.originalLabel;
    const translatedLink = component.translatedLink;
    const translatedLabel = component.translatedLabel;
    const popover = (react_1.default.createElement(react_bootstrap_1.Popover, { id: "popover-basic", style: { maxWidth: 1000 } },
        react_1.default.createElement(react_bootstrap_1.Popover.Header, { as: "h3" }, "\u062A\u0631\u062C\u0645\u0629"),
        react_1.default.createElement(react_bootstrap_1.Popover.Body, null,
            react_1.default.createElement("div", null,
                react_1.default.createElement("p", null,
                    "\u0627\u0644\u0631\u0627\u0628\u0637 \u0627\u0644\u0627\u0635\u0644\u064A: ",
                    originalLink),
                react_1.default.createElement("p", null,
                    "\u0627\u0644\u0631\u0627\u0628\u0637 \u0627\u0644\u0645\u062A\u0631\u062C\u0645: ",
                    translatedLink),
                react_1.default.createElement("p", null,
                    "\u0627\u0644\u0646\u0635 \u0627\u0644\u0645\u062A\u0631\u062C\u0645: ",
                    translatedLabel)))));
    if (originalLabel)
        return react_1.default.createElement("div", null,
            react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { trigger: "click", placement: "bottom", overlay: popover },
                react_1.default.createElement("div", { dir: originalDir },
                    react_1.default.createElement("u", null, originalLabel))));
    else if (translatedLabel)
        return react_1.default.createElement("div", null,
            react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { trigger: "click", placement: "bottom", overlay: popover },
                react_1.default.createElement("div", { dir: translatedDir },
                    react_1.default.createElement("u", null, translatedLabel))));
    else
        return null;
}
exports.LinkComponentRender = LinkComponentRender;
function LinkComponentWebsiteRender(props) {
    const component = props.component;
    const originalDir = props.originalDir;
    const translatedDir = props.translatedDir;
    const originalLink = component.originalLink;
    const originalLabel = component.originalLabel;
    const translatedLink = component.translatedLink;
    const translatedLabel = component.translatedLabel;
    if (translatedLabel)
        return react_1.default.createElement("div", null,
            react_1.default.createElement("a", { href: translatedLink, dir: translatedDir }, translatedLabel));
    else if (originalLabel)
        return react_1.default.createElement("div", null,
            react_1.default.createElement("a", { href: originalLink, dir: originalDir }, originalLabel));
    else
        return null;
}
exports.LinkComponentWebsiteRender = LinkComponentWebsiteRender;
function LinkComponentCreator(props) {
    const dispatch = props.dispatch;
    const [original, setoriginal] = react_1.default.useState('');
    const [translated, settranslated] = react_1.default.useState(null);
    const [originalLabel, setoriginalLabel] = react_1.default.useState('');
    const [translatedLabel, settranslatedLabel] = react_1.default.useState('');
    return react_1.default.createElement("div", { className: 'my-3' },
        react_1.default.createElement(react_bootstrap_1.FloatingLabel, { label: "\u0627\u0644\u0631\u0627\u0628\u0637 \u0627\u0644\u0627\u0635\u0644\u064A" },
            react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "textarea", style: { height: '100px' }, onChange: (e) => {
                    setoriginal(e.target.value);
                    dispatch((0, structure_1.linkObject)(e.target.value, originalLabel, translated, translatedLabel));
                } })),
        react_1.default.createElement(react_bootstrap_1.FloatingLabel, { label: "\u0646\u0635 \u0627\u0644\u0631\u0627\u0628\u0637 \u0627\u0644\u0627\u0635\u0644\u064A" },
            react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "input", type: 'text', value: originalLabel, style: { height: '100px' }, onChange: (e) => {
                    setoriginalLabel(e.target.value);
                    dispatch((0, structure_1.linkObject)(original, e.target.value, translated, translatedLabel));
                } })),
        react_1.default.createElement(react_bootstrap_1.FloatingLabel, { label: "\u0627\u0644\u0631\u0627\u0628\u0637 \u0627\u0644\u0645\u062A\u0631\u062C\u0645" },
            react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "textarea", style: { height: '100px' }, onChange: (e) => {
                    settranslated(e.target.value);
                    dispatch((0, structure_1.linkObject)(original, originalLabel, e.target.value, translatedLabel));
                } })),
        react_1.default.createElement(react_bootstrap_1.FloatingLabel, { label: "\u0646\u0635 \u0627\u0644\u0631\u0627\u0628\u0637 \u0645\u062A\u0631\u062C\u0645" },
            react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "input", type: 'text', value: translatedLabel, style: { height: '100px' }, onChange: (e) => {
                    settranslatedLabel(e.target.value);
                    dispatch((0, structure_1.linkObject)(original, originalLabel, translated, e.target.value));
                } })));
}
exports.LinkComponentCreator = LinkComponentCreator;
function LinkComponentEditor(props) {
    const component = props.component;
    const dispatch = props.dispatch;
    const [originalLink, setoriginalLink] = react_1.default.useState(component.originalLink);
    const [originalLabel, setoriginalLabel] = react_1.default.useState(component.originalLabel);
    const [translatedLink, settranslatedLink] = react_1.default.useState(component.translatedLink);
    const [translatedLabel, settranslatedLabel] = react_1.default.useState(component.translatedLabel);
    return react_1.default.createElement("div", null,
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", null, "\u0627\u0644\u0631\u0627\u0628\u0637 \u0627\u0644\u0627\u0635\u0644\u064A"),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "input", value: originalLink !== null && originalLink !== void 0 ? originalLink : '', onChange: (e) => {
                    setoriginalLink(e.target.value);
                    dispatch((0, structure_1.linkObject)(e.target.value, originalLabel, translatedLink, translatedLabel));
                } }),
            react_1.default.createElement("div", null, "\u0627\u0644\u0646\u0635 \u0627\u0644\u0627\u0635\u0644\u064A"),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "input", value: originalLabel !== null && originalLabel !== void 0 ? originalLabel : '', onChange: (e) => {
                    setoriginalLabel(e.target.value);
                    dispatch((0, structure_1.linkObject)(originalLink, e.target.value, translatedLink, translatedLabel));
                } }),
            react_1.default.createElement("div", null, "\u0627\u0644\u0631\u0627\u0628\u0637 \u0627\u0644\u0645\u062A\u0631\u062C\u0645"),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "input", value: translatedLink !== null && translatedLink !== void 0 ? translatedLink : '', onChange: (e) => {
                    settranslatedLink(e.target.value);
                    dispatch((0, structure_1.linkObject)(originalLink, originalLabel, e.target.value, translatedLabel));
                } }),
            react_1.default.createElement("div", null, "\u0627\u0644\u0646\u0635 \u0627\u0644\u0645\u062A\u0631\u062C\u0645"),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "input", value: translatedLabel !== null && translatedLabel !== void 0 ? translatedLabel : '', onChange: (e) => {
                    settranslatedLabel(e.target.value);
                    dispatch((0, structure_1.linkObject)(originalLink, originalLabel, translatedLink, e.target.value));
                } })));
}
exports.LinkComponentEditor = LinkComponentEditor;
